import React, { Component } from "react";
import configuration from "react-global-configuration";
import VideoComponent from "../../components/User/Video/Video";
import VideoPlayerIndex from "../../components/VideoPlayer/VideoPlayerIndex";
import {
  resolvePlaybackEngine,
  PlaybackEngineId,
} from "./resolvePlaybackEngine";
import HostPlaybackPage from "./HostPlaybackPage";

/**
 * Unified playback entry for /video/:id and /v/:id.
 *
 * Default production path (UMXP):
 *   PlaybackEntry → HostPlaybackPage → NextGenPlayer → PlaybackEngine → Registry
 *
 * Rollback only (explicit):
 *   ?player=legacy | ?player=jw | ?player=react-player
 *   localStorage.playback_engine_override
 *   REACT_APP_PLAYBACK_ENGINE=legacy|jw
 *   configData.playback_engine=legacy|jw|react-player
 */
class PlaybackEntry extends Component {
  render() {
    var engine = resolvePlaybackEngine({ configuration: configuration });

    if (engine === PlaybackEngineId.JW) {
      return (
        <div data-playback-engine="jw" data-umxp="0">
          <VideoPlayerIndex {...this.props} />
        </div>
      );
    }

    if (engine === PlaybackEngineId.REACT_PLAYER) {
      return (
        <div data-playback-engine="react-player" data-umxp="0">
          <VideoComponent {...this.props} />
        </div>
      );
    }

    // Default: UMXP / nextgen — never fall through to ReactPlayer or JW
    return (
      <div data-playback-engine="nextgen" data-umxp="1">
        <HostPlaybackPage {...this.props} />
      </div>
    );
  }
}

export default PlaybackEntry;
